import { Box } from '@mui/material'
import RegisterForm from '~/src/components/auth/register/RegisterForm'
import Title from '~/src/components/mui-wrappers/Title'
import { useTranslations } from '~/src/hooks/useTranslations'

const RegisterContainer = () => {
  const { t } = useTranslations()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 6
      }}
    >
      <Box>
        <Title variant='h3'>
          {t('auth.sign_in')}
        </Title>
        <Title variant='h6'>
          {t('auth.create_an_account_to_be_able_to_order_our_delicious_food')}
        </Title>
      </Box>
      <RegisterForm />
    </Box>
  )
}

export default RegisterContainer
